'use client';
import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { useBrandLogos } from '@/hooks/useBrandLogos';

export default function LandingFooter() {
  const { logoWordmarkUrl } = useBrandLogos();

  return (
    <footer className="py-12" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <AppLogo size={28} />
              {logoWordmarkUrl ? (
                <img src={logoWordmarkUrl} alt="Ovation Programs" className="h-5 object-contain" />
              ) : (
                <span className="font-bold text-base text-gradient-gold">Ovation Programs</span>
              )}
            </div>
            <p className="text-xs text-zinc-500 max-w-xs leading-relaxed">
              Beautiful digital theatre programs for schools and venues. Create, share, and print.
            </p>
          </div>

          <div className="flex gap-12 text-sm">
            <div>
              <div className="font-semibold text-zinc-300 mb-3">Product</div>
              <div className="space-y-2">
                <Link href="/landing-page#features" className="block text-zinc-500 hover:text-zinc-300 transition-colors">Features</Link>
                <Link href="/landing-page#programs" className="block text-zinc-500 hover:text-zinc-300 transition-colors">Browse</Link>
                <Link href="/landing-page#pricing" className="block text-zinc-500 hover:text-zinc-300 transition-colors">Pricing</Link>
              </div>
            </div>
            <div>
              <div className="font-semibold text-zinc-300 mb-3">Account</div>
              <div className="space-y-2">
                <Link href="/sign-up-login-screen" className="block text-zinc-500 hover:text-zinc-300 transition-colors">Sign In</Link>
                <Link href="/sign-up-login-screen" className="block text-zinc-500 hover:text-zinc-300 transition-colors">Sign Up</Link>
                <Link href="/admin-dashboard" className="block text-zinc-500 hover:text-zinc-300 transition-colors">Admin</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <p className="text-xs text-zinc-600">© 2026 Ovation Programs. All rights reserved.</p>
          <p className="text-xs text-zinc-600">Built for theatres that deserve better programs.</p>
        </div>
      </div>
    </footer>
  );
}